"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
class Delay {
    constructor() {
        this.$timeOut = 1500;
        this.$handler = function () {
            console.log('Empty Callback...');
        };
    }
    time(data) {
        this.$timeOut = data;
        return this;
    }
    handler(callback) {
        this.$handler = callback;
        return this;
    }
    fire() {
        setTimeout(() => {
            this.$handler();
        }, this.$timeOut);
    }
}
exports.default = Delay;
function delay() {
    return new Delay();
}
exports.delay = delay;
